import { ReactNode, useState } from "react";
import { Collapse } from "react-collapse";

import ChevronDownIcon from "@assets/icons/chevron-down.svg";

import { cn } from "@utils/tailwind.util";

interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
  // Collapsed unless told otherwise.
  defaultOpen?: boolean;
  className?: string;
}

// A titled section that folds away: a tinted header on the outer border, and the content in its
// own card inside it.
export function CollapsibleSection({
  title,
  children,
  defaultOpen = false,
  className,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div
      className={cn(
        "rounded-xl bg-background-secondary",
        "dark:border-gray-600 dark:bg-gray-750",
        className
      )}
    >
      <button
        type="button"
        aria-expanded={isOpen}
        className="flex w-full items-center justify-between gap-2 px-4 py-3"
        onClick={() => setIsOpen((open) => !open)}
      >
        <span className="text-sm font-medium text-content-secondary dark:text-invertedPrimary80">
          {title}
        </span>
        <ChevronDownIcon
          width={20}
          height={20}
          className={cn(
            "flex-shrink-0 text-content-secondary transition-transform duration-300 dark:text-invertedPrimary80",
            isOpen ? "rotate-0" : "-rotate-90"
          )}
        />
      </button>

      <Collapse isOpened={isOpen}>
        <div className="p-0.5 pt-0">
          <div className="rounded-lg border border-stroke-primary bg-background-primary p-3 dark:border-gray-600 dark:bg-gray-800">
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  );
}
